import {DynField} from '../dyn-field';

export class DynStaticTextField
    extends DynField {

    constructor() {
        super(null, 'static-text')
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/dyn-static-text-field.ts